import React from "react";

import pdf from "@react-pdf/renderer";

import { graphql } from "@/gql";
import { FragmentType } from "@/utils/type";

import PDFCommonFEL from "./PDFCommonFEL";
import PDFFelTemplate from "./PDFFelTemplate";
import PDFHouseholdMeasurementTemplate from "./PDFHouseholdMeasurementTemplate";
import PDFMealPattern from "./PDFMealPattern";
import PDFMealTemplate from "./PDFMealTemplate";
import PDFShoppingListTemplate from "./PDFShoppingListTemplate";

const { Document } = pdf;

export interface PDFSectionsProp {
  mealPlan: boolean;
  mealPattern: boolean;
  shoppingList: boolean;
  householdMeasurements: boolean;
  foodExchangeList: boolean;
  commonExchangeList: boolean;
}

type Props = {
  enabledSections?: Partial<PDFSectionsProp>;
  pdfData: FragmentType<typeof pdfDocumentsFragment>;
};

const pdfDocumentsFragment = graphql(`
  fragment PDFDocuments on Program {
    id
    ...PDFMealTemplate_Header
    ...PDFFelTemplate
    mealPlan {
      id
      ...PDFMealPattern
      plannedMealsByDate {
        ...PDFMealTemplate_PlannedMeals
      }
      asWeeklyShoppingList {
        ...PDFShoppingListTemplate
      }
    }
  }
`);

const PDFDocuments: React.FC<Props> = ({
  pdfData,
  enabledSections = {
    commonExchangeList: true,
    foodExchangeList: true,
    householdMeasurements: true,
    mealPattern: true,
    mealPlan: true,
    shoppingList: true,
  },
}) => {
  return (
    <Document>
      {enabledSections.mealPlan &&
        pdfData.mealPlan?.plannedMealsByDate?.map((data, index) => (
          <PDFMealTemplate
            key={data.date}
            day={index + 1}
            headerData={pdfData}
            plannedMealsData={data}
          />
        ))}
      {enabledSections.mealPattern && !!pdfData.mealPlan && (
        <PDFMealPattern data={pdfData.mealPlan} headerData={pdfData} />
      )}
      {enabledSections.shoppingList &&
        pdfData.mealPlan?.asWeeklyShoppingList?.map((data, index) => (
          <PDFShoppingListTemplate key={index} data={data} />
        ))}
      {enabledSections.householdMeasurements && (
        <PDFHouseholdMeasurementTemplate />
      )}
      {enabledSections.foodExchangeList && <PDFFelTemplate data={pdfData} />}
      {enabledSections.commonExchangeList && <PDFCommonFEL />}
    </Document>
  );
};

export default PDFDocuments;
